module.exports = __webpack_public_path__ + "img/login_bottom.c78c1fa4.png";